import { selectCount } from 'features/learners/slice';
import { useSelector } from 'react-redux';

import {
  LinkWithButtonStyles,
  Heading,
  Image,
} from '@frontendmentorio/design-system-v2';

import GitHubAuthButton from 'features/shared/GitHubAuthButton';

export default function Hero() {
  const userCount = useSelector(selectCount);

  return (
    <section className="overflow-hidden px-5 py-7 tablet:py-8">
      <div className="container-xl flex flex-col gap-6 tablet:flex-row tablet:gap-6">
        <div className="flex flex-col gap-5 items-start justify-center tablet:max-w-[38.5rem] tablet:min-w-[30rem] tablet:w-[60%]">
          <Heading
            className="font-secondary italic text-lg tracking-wider"
            level="2"
            tagName="span"
          >
            For learners
          </Heading>

          <Heading className="text-blue-800" level="1">
            Front-end and full-stack coding challenges that build real skills
            and help get you hired
          </Heading>

          <p className="text-neutral-500 text-lg">
            Frontend Mentor provides professional design-to-code challenges that
            mirror real-world development work. Join{' '}
            <span className="font-bold text-blue-800">{userCount}</span>{' '}
            developers building portfolio projects that impress employers.
          </p>

          <div className="flex flex-wrap gap-4">
            <GitHubAuthButton level="secondary">
              Start building free
            </GitHubAuthButton>

            <LinkWithButtonStyles
              className="border-neutral-200 hover:border-neutral-200"
              href="/challenges"
              level="tertiary"
            >
              Browse challenges
            </LinkWithButtonStyles>
          </div>
        </div>

        <Image
          alt="Design mockup, mobile site, and code editor"
          className="object-cover object-left rounded-2xl tablet:max-w-[40%]"
          height={1040}
          priority
          quality={100}
          src="/static/images/home-hero.webp"
          width={1096}
        />
      </div>
    </section>
  );
}
